"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCatalogueItemBlackouts = void 0;
/**
 * Get blackout dates and days for a catalogue item by its SKU
 */
var getCatalogueItemBlackouts = function (instance) {
    return function (id, sku, config) {
        return instance.get("/catalogues/".concat(id, "/items/").concat(sku, "/blackouts"), config);
    };
};
exports.getCatalogueItemBlackouts = getCatalogueItemBlackouts;
